import { useState } from 'react';

import { Folder } from '@qality/common-model';

export type FolderTree = ReturnType<typeof useFoldersTree>;

export function useFoldersTree() {
  const [tree, setTree] = useState<Record<Folder['id'], boolean>>({});

  const expandFolder = (folderId: Folder['id']) => {
    setTree((oldFoldersTree) => ({
      ...oldFoldersTree,
      [folderId]: true,
    }));
  };

  const collapseFolder = (folderId: Folder['id']) => {
    setTree((oldFoldersTree) => ({
      ...oldFoldersTree,
      [folderId]: false,
    }));
  };

  const isFolderExpanded = (folderId: Folder['id']) => {
    return tree[folderId] ?? false;
  };

  return {
    expandFolder,
    collapseFolder,
    isFolderExpanded,
  };
}
